import { LoginState } from './login/login.state';
import { ActionReducerMap } from '@ngrx/store';
import { loginReducer } from './login/login.reducers';
import { ProfileState } from './profile/profile.state';
import { profileReducer } from './profile/profile.reducers';
import { LoginEffects } from './login/login.effects';
import { ProfileEffects } from './profile/profile.effects';
import { ShipmentsTableState } from './shipments-table/shipments-table.state';
import { shipmentsTableReducer } from './shipments-table/shipments-table.reducers';
import { ShipmentsTableEffects } from './shipments-table/shipments-table.effects';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { RouterEffects } from './router/router.effects';
import { ShipmentEditorState } from './shipment-editor/shipment-editor.state';
import { shipmentEditorReducer } from './shipment-editor/shipment-editor.reducers';
import { ShipmentEditorEffects } from './shipment-editor/shipment-editor.effects';
import { QuoteProgressState } from './quote-progress/quote-progress.state';
import { quoteProgressReducer } from './quote-progress/quote-progress.reducers';
import { JournalState } from './journal/journal.state';
import { journalReducer } from './journal/journal.reducers';
import { QuoteProgressEffects } from './quote-progress/quote-progress.effects';
import { JournalEffects } from './journal/journal.effects';
import { InterfaceState } from './interface/interface.state';
import { interfaceReducer } from './interface/interface.reducers';
import { InterfaceEffects } from './interface/interface.effects';
import { AddressBooksTableState } from './address-books-table/address-books-table.state';
import { addressBooksTableReducer } from './address-books-table/address-books-table.reducers';
import { AddressBooksTableEffects } from './address-books-table/address-books-table.effects';
import { ContactsTableState } from './contacts-table/contacts-table.state';
import { contactsTableReducer } from './contacts-table/contacts-table.reducers';
import { ContactsTableEffects } from './contacts-table/contacts-table.effects';
import { InvoiceTableState } from './invoice-table/invoice-table.state';
import { invoiceTableReducer } from './invoice-table/invoice-table.reducers';
import { InvoiceTableEffects } from './invoice-table/invoice-table.effects';
import { PickupTableState } from './pickup-table/pickup-table.state';
import { pickupTableReducer } from './pickup-table/pickup-table.reducers';
import { PickupTableEffects } from './pickup-table/pickup-table.effects';
import { PickupState } from './pickup/pickup.state';
import { pickupReducer } from './pickup/pickup.reducers';
import { PickupEffects } from './pickup/pickup.effects';
import { BatchTableState } from './batch-table/batch-table.state';
import { batchTableReducer } from './batch-table/batch-table.reducers';
import { BatchTableEffects } from './batch-table/batch-table.effects';
import { MessengerEffects } from './messenger/messenger.effects';
import { ShipmentState } from './shipment/shipment.state';
import { shipmentReducer } from './shipment/shipment.reducers';
import { ShipmentEffects } from './shipment/shipment.effects';
import { PaymentState } from './payment/payment.state';
import { paymentReducer } from './payment/payment.reducers';
import { PaymentEffects } from './payment/payment.effects';
import { ContactEditorState } from './contact-editor/contact-editor.state';
import { contactEditorReducer } from './contact-editor/contact-editor.reducers';
import { ContactEditorEffects } from './contact-editor/contact-editor.effects';
import { PackageTableState } from './package-table/package-table.state';
import { packageTableReducer } from './package-table/package-table.reducers';
import { commodityTableReducer } from './commodity-table/commodity-table.reducers';
import { CommodityTableState } from './commodity-table/commodity-table.state';
import { PackageTableEffects } from './package-table/package-table.effects';
import { CommodityTableEffects } from './commodity-table/commodity-table.effects';
import { CommodityEditorState } from './commodity-editor/commodity-editor.state';
import { commodityEditorReducer } from './commodity-editor/commodity-editor.reducers';
import { CommodityEditorEffects } from './commodity-editor/commodity-editor.effects';
import { PackageEditorEffects } from './package-editor/package-editor.effects';
import { PackageEditorState } from './package-editor/package-editor.state';
import { packageEditorReducer } from './package-editor/package-editor.reducers';

export interface AppState {
    login: LoginState;
    profile: ProfileState;
    shipmentsTable: ShipmentsTableState;
    addressBooksTable: AddressBooksTableState;
    contactsTable: ContactsTableState;
    invoiceTable: InvoiceTableState;
    pickupTable: PickupTableState;
    batchTable: BatchTableState;
    router: RouterReducerState<any>;
    shipmentEditor: ShipmentEditorState;
    quoteProgress: QuoteProgressState;
    journal: JournalState;
    interface: InterfaceState;
    pickup: PickupState;
    shipment: ShipmentState;
    payment: PaymentState;
    contactEditor: ContactEditorState;
    packageTable: PackageTableState;
    commodityTable: CommodityTableState;
    commodityEditor: CommodityEditorState;
    packageEditor: PackageEditorState;
}

export const reducers: ActionReducerMap<AppState> = {
    login: loginReducer,
    profile: profileReducer,
    shipmentsTable: shipmentsTableReducer,
    addressBooksTable: addressBooksTableReducer,
    contactsTable: contactsTableReducer,
    invoiceTable: invoiceTableReducer,
    pickupTable: pickupTableReducer,
    batchTable: batchTableReducer,
    router: routerReducer,
    shipmentEditor: shipmentEditorReducer,
    quoteProgress: quoteProgressReducer,
    journal: journalReducer,
    interface: interfaceReducer,
    pickup: pickupReducer,
    shipment: shipmentReducer,
    payment: paymentReducer,
    contactEditor: contactEditorReducer,
    packageTable: packageTableReducer,
    commodityTable: commodityTableReducer,
    commodityEditor: commodityEditorReducer,
    packageEditor: packageEditorReducer
};

export const effects = [
    LoginEffects,
    ProfileEffects,
    ShipmentsTableEffects,
    AddressBooksTableEffects,
    ContactsTableEffects,
    InvoiceTableEffects,
    PickupTableEffects,
    BatchTableEffects,
    RouterEffects,
    ShipmentEditorEffects,
    QuoteProgressEffects,
    JournalEffects,
    InterfaceEffects,
    PickupEffects,
    MessengerEffects,
    ShipmentEffects,
    PaymentEffects,
    ContactEditorEffects,
    PackageTableEffects,
    CommodityTableEffects,
    CommodityEditorEffects,
    PackageEditorEffects
];
